import styled from "styled-components";

export const ContainerComponentsPageStyle = styled.div`
  .accordion-button {
    outline: none !important;
    box-shadow: none !important;
    border: 0px !important;
    color: var(--preto-primario) !important;
  }

  .accordion-button.collapsed {
    background-color: var(--branco-primario) !important;
    color: var(--preto-primario) !important;
  }

  .accordion-body {
    background-color: var(--branco-primario) !important;
    color: var(--preto-primario) !important;
  }

  .accordion-button:not(.collapsed) {
    background-color: var(--verde-primario4) !important;
    background-image: none !important;
    color: var(--branco-secundario) !important;

    ::after {
      filter: invert(100%) !important;
    }
  }

  .code-container {
    background-color: #111;
    padding: 0.5rem;
  }

  .box-aviso {
    background-color: #e6bb00;
    border-radius: 0.5rem;
    padding: 0.5rem;
  }
`;
